import type { Location as YandexLocation } from "@components/feed-map/types"
import { calculateDistance } from "@common/yandex/RadiusCalculator";
import { FilterType } from "@shared/filter/types";
export type LocationFilterParts = Pick<FilterType, "longitude" | "latitude"  | "distanceInMeters">
export  const locationFilter = (location :YandexLocation):Readonly<LocationFilterParts> => {
  const latitude = location.center[1]
  const longitude = location.center[0]
  const distanceInMeters = calculateDistance(location.bounds)
  return {latitude, longitude, distanceInMeters}
}
export const generateLocationFilter = (loc: YandexLocation, extra: FilterType): Readonly<FilterType> => {
  const locFilter = locationFilter(loc)
  const commonFilter = { ...extra, ...locFilter}
  commonFilter.city = undefined
  return commonFilter
}